import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListableInstrumentsComponent } from './listable-instruments.component';
import { ListableInstrumentsTableComponent } from '../available-listable-instruments/available-listable-instruments.component';
import { InstrumentFilterSearchComponent } from '../instrument-filter-search/instrument-filter-search.component';
import { InstrumentFilterCheckboxesModule } from '../instrument-filter-checkboxes/instrument-filter-checkboxes.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TooltipButtonModule } from '../tooltip-button/tooltip-button.module';
import { ButtonModule } from '../button/button.module';
import { FormsModule } from '@angular/forms';
import { AvailableInstrumentTogglerModule } from '../available-instrument-toggler/available-instrument-toggler.module';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [
    ListableInstrumentsComponent,
    ListableInstrumentsTableComponent,
    InstrumentFilterSearchComponent,
  ],
  imports: [
    CommonModule,
    InstrumentFilterCheckboxesModule,
    TranslateModule,
    AngularSvgIconModule,
    TooltipButtonModule,
    ButtonModule,
    FormsModule,
    AvailableInstrumentTogglerModule,
    NgxPaginationModule,

  ],
  exports: [
    ListableInstrumentsComponent
  ],
  providers: [
    TranslatePipe,
  ],
})
export class ListableInstrumentsModule { }
